import React, { useState } from "react";
import { accountDeleteLogin, otpVerify } from "../../utils/routes";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import OTPInput, { ResendOTP } from "otp-input-react";
import { FaArrowLeft } from "react-icons/fa";

export const Otp = ({ setIsValidOTP, setAuthentication, getLoggedInUser }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [OTP, setOTP] = useState(null);

  const onSubmit = () => {
    setIsLoading(true);

    const dto = {
      otp: OTP,
      accountId: getLoggedInUser.accountId,
      otpType: "login",
    };
    const getUserRequestDTO = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dto),
    };

    fetch(otpVerify, getUserRequestDTO)
      .then((res) => res.json())
      .then((result) => {
        if (result.statusCode === 0) {
          setIsValidOTP(true);
          toast.success(result.result.description);
        } else {
          toast.error(result.statusDescription);
        }
        setIsLoading(false);
      });
  };

  const resendOTP = () => {
    setOTP(null);
    let num = "";
    if (getLoggedInUser.username.startsWith("0")) {
      let strippedNumber = getLoggedInUser.username.replace(/^0+/, "");
      // Add +92
      // number = getLoggedInUser.username.substring(1);
      num = `+92${strippedNumber}`;
    }
    const getUserRequestDTO = {
      method: "POST",

      headers: {
        "Content-Type": "application/json",
        userName: num ? num : getLoggedInUser.username,
        password: btoa(getLoggedInUser.password),
        channelId: "mobile",
      },
    };

    fetch(accountDeleteLogin, getUserRequestDTO)
      .then((res) => res.json())
      .then((result) => {
        if (result.statusCode == 0) {
          toast.success(result.result.description);
        }
      });
  };
  return (
    <>
      <span
        onClick={() => setAuthentication(false)}
        className="btn-icon"
        style={{ position: "absolute", left: "1rem", top: "1rem", zIndex: 1 }}
      >
        <FaArrowLeft color="white" />
      </span>{" "}
      <div className="form-group">
        <input type="password" name="onezappOTP" autoComplete="off" hidden />
        <div className="otp-wrapper">
          <h5 className="form-label me-auto mb-0">Enter OTP</h5>
          <small
            className="d-inline-block w-100 mb-4"
            style={{ color: "#785d78" }}
          >
            Please enter your OTP, received on your register mobile number.
          </small>
          <OTPInput
            name="onezappOTP"
            className="otp-inputs-wrapper"
            inputClassName="form-control"
            value={OTP}
            onChange={setOTP}
            OTPLength={6}
            otpType="number"
            autoComplete="off"
            disabled={false}
            autoFocus
            secure
          />

          <ResendOTP
            className="otp-resend"
            maxTime={60}
            onResendClick={resendOTP}
          />
        </div>
      </div>
      <div className="d-flex gap-3 justify-content-between">
        <button
          className="btn btn-contect mt-4"
          type="button"
          onClick={onSubmit}
        >
          Submit
        </button>
      </div>
    </>
  );
};
